import { render, staticRenderFns } from "./StoreEdit.vue?vue&type=template&id=3edd65c4&scoped=true&"
import script from "./StoreEdit.vue?vue&type=script&lang=js&"
export * from "./StoreEdit.vue?vue&type=script&lang=js&"
import style0 from "./StoreEdit.vue?vue&type=style&index=0&id=3edd65c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd65c4",
  null
  
)

export default component.exports